import { QueryClient } from "react-query";
import { AxiosError } from "axios";

const NON_RETRYABLE_CODES = [400, 401, 403, 404, 409];

export function shouldRetry(failureCount: number, error: unknown): boolean {
  const code = (error as AxiosError)?.response?.status ?? 0;
  if (NON_RETRYABLE_CODES.includes(code)) {
    return false;
  }
  return failureCount < 3;
}

export function generateQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 600000, // 10 minutes
        cacheTime: 900000, // 15 minutes
        refetchOnMount: true,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
        retry: shouldRetry,
      },
      mutations: {
        retry: shouldRetry,
      },
    },
  });
}

export const queryClient = generateQueryClient();
